import React, { useEffect, useState } from "react";
import Head from "next/head";
import striptags from "striptags";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";

const Layout = dynamic(() => import("../components/common/Layout/Layout"));
const Loader = dynamic(() => import("../components/common/Loader/Loader"));

const termscondition = ({ apiData }) => {
  const [conditionData, setConditionData] = useState();
  const [loader, setLoader] = useState(true);
  const title = apiData?.page_title;
  const seo_title = apiData?.meta?.seo_title;
  const search_description = apiData?.meta?.search_description;
  const canonicalUrl = apiData?.canonical_url;
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;
  const structuredData = apiData?.struct_org_extra_json;
  const formatJson = (json) => {
    return {
      __html: `${json}`,
    };
  }

  const footerData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  useEffect(() => {
    const termsData = apiData?.detail;
    termsData && setConditionData(termsData);
    if (footerData) {
      setLoader(false);
    }
  }, []);

  return (
    <>
      <Head>
        <title>{striptags(title)}</title>

        <meta name="title" content={seo_title} key="og-title" />

        <meta name="description" content={search_description} key="og-desc" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />
        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}
      </Head>
      <Layout
        webLogo={
          footerData &&
          footerData?.site_configuration &&
          footerData?.site_configuration[0]?.logo?.url
        }
      >
        {loader && <Loader />}
        <main className="main-wrapper terms-policy-middle wrapper-top-bg">
          <article className="wrapper-inner">
            <section className="default-hero-section light-primary-background">
              <div
                className="default-hero-inner"
                style={{
                  marginBottom: "80px",
                }}
              >
                <div className="container">
                  <div className="row">
                    {conditionData?.map((val, index) => {
                      const titleWithoutPTag = striptags(
                        val?.value?.title,
                        "<span>"
                      );
                      return (
                        <React.Fragment key={`${index}_j`}>
                          {val?.type ==
                            "title_description_paragraph_section" && (
                              <div className="col-lg-12">
                                <div className="heading">
                                  <h1
                                    className="heading-h1"
                                    itemProp="heading"
                                    dangerouslySetInnerHTML={{
                                      __html: titleWithoutPTag,
                                    }}
                                  ></h1>
                                </div>
                              </div>
                            )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </div>
            </section>
            <section className="terms-policy-section">
              <div className="terms-policy-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      {conditionData?.map((val, i) => {
                        return (
                          <React.Fragment key={`${i}_j`}>
                            {val?.type ==
                              "title_description_paragraph_section" && (
                                <div
                                  className="terms-policy-content"
                                  dangerouslySetInnerHTML={{
                                    __html: val?.value?.paragraph,
                                  }}
                                ></div>
                              )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </article>
        </main>
      </Layout>
    </>
  );
};

export async function getServerSideProps() {
  // Fetch data from your API
  const response = await fetch(
    process.env.NEXT_PUBLIC_API_ENDPOINT + "/cms/pages/terms-of-service/",
    { next: { revalidate: 3600 } }
  );
  const apiData = await response.json();

  return {
    props: {
      apiData,
    },
  };
}

export default termscondition;
